<lib-prod-grid
  [title]="prodGridTitle"
  [icon]="'dataset'"
  [columns]="prodGridColumns"
  [class]="'distributor-tab'"
  [isAddButtonShown]="true"
  [isAddButtonDisabled]="prodGridToolbarButtonsStatus.isAddButtonDisabled.disabled"
  [isEditButtonShown]="prodGridToolbarButtonsStatus.isEditButtonShown.disabled"
  [isRemoveButtonShown]="true"
  [isRemoveButtonDisabled]="prodGridToolbarButtonsStatus.isRemoveButtonDisabled.disabled"
  [matTableDataSource]="matTableDataSource"
  [inputAction$]="inputAction$"
  (outputAction$)="outputActionEvents($event)"></lib-prod-grid>

